import React, { useState } from "react";
import { FormattedHTMLMessage, useIntl } from "gatsby-plugin-intl";
import ModalPopup from "../modal";
import "./earthquakeNoticeModal.scss";

const EarthquakeNoticeModal = () => {
  const [showModal, setShowModal] = useState(true);
  const intl = useIntl();

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <ModalPopup
      show={showModal}
      onClose={handleClose}
      heading={intl.formatMessage({ id: "earthquakeModalTitle" })}
      size="lg"
    >
      <hr className="earthquake-modal-divider" />
      <div className="earthquake-notice-content">
        <FormattedHTMLMessage id="earthquakeModalContent" />
      </div>
    </ModalPopup>
  );
};

export default EarthquakeNoticeModal;
